module.exports = __webpack_public_path__ + "static/media/project1.457c4fe9.png";